<template>
	<div class="list-domains">
		<table-list
			:items="domains"
			:loading="loading"
			>

			<template slot="header">
				<span
					:class="`domains-header-item domains-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					{{ col }}
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<router-link
					:class="`domains-item domains-item--${key} domains-item--${item.status}`"
					:key="`item_${key}`"
					:to="{ name: 'domain', params: { domainId: item.domainId } }"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</router-link>
			</template>
		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'
import { BannerStatus } from '@/lib/enums'

import TableList from '@/components/TableList'

export default {
	name: 'ListDomains',
	components: {
		TableList,
	},
	props: {
		domains: {
			type: Array,
			default: () => ([]),
		},
		loading: Boolean,
	},
	data: () => ({
		columns: {
			domain: 'Domain',
			dateCreated: 'Created',
			status: 'Status',
		},
	}),
	methods: {
		transform(key, value) {
			switch(key) {
				case 'dateCreated':
					try {
						const dt = parseISO(value)
						value = `<span title="${format(dt, 'Pp')}">${formatDistanceToNowStrict(dt, { addSuffix: true})}</span>`
					} catch (error) {
						console.warn(error)
					}
					return value
				case 'status':
					return BannerStatus[value]
				default:
					break
			}

			return value
		},
		get,
	},
}
</script>

<style scoped lang="scss">
.list-domains {
	&__heading {
		@include modules.gutter('padding-left');
		@include modules.gutter('padding-right');
	}

	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('background', 'medium');
			display: grid;
			grid-template-columns: repeat(2, 1fr) minmax(140px, auto);

			@include modules.media-query('phone') {
				grid-template-columns: 1fr 1fr;
			}
		}
	}

	.domains-header-item {
		@include modules.fontSize(14px);
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.domains-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}

		&--removed {
			opacity: 0.7;

			&.domains-item--status {
				color: modules.color_('alert', 'critical')
			}
		}
	}
}
</style>
